import type { IFlowButton } from '@/types/flowbutton';
import type { FlowHandler, ActionMenuItem } from './index';

export const partCreateHandler: FlowHandler = {
  getMenuItems(button: IFlowButton): ActionMenuItem[] {
    const config = button.flow_config || {};
    const items: ActionMenuItem[] = [
      {
        icon: '📄',
        label: 'Scan & Create Part',
        onClick: () => {},
        openDialog: 'part-create-pipeline',
      },
    ];

    if (config.enable_batch_mode) {
      items.push({
        icon: '📋',
        label: 'Scan & Create Parts (Batch)',
        onClick: () => {},
        openDialog: 'part-create-pipeline',
      });
    }

    items.push({
      icon: '📊',
      label: 'View Part Code Sheet',
      onClick: () => {
        window.open('/app/psi/partcodes', '_self');
      },
    });

    return items;
  },
};
